import { render, staticRenderFns } from "./CustomLanguageDropdown.vue?vue&type=template&id=1dadbc30&scoped=true&"
import script from "./CustomLanguageDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomLanguageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CustomLanguageDropdown.vue?vue&type=style&index=0&id=1dadbc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dadbc30",
  null
  
)

export default component.exports